export const GET_CUSTOMER_RECENT_APPOINTMENTS =
  "GET_CUSTOMER_RECENT_APPOINTMENTS";
export const GOT_CUSTOMER_RECENT_APPOINTMENTS =
  "GOT_CUSTOMER_RECENT_APPOINTMENTS";
export const SET_IS_LOADING_RECENT_APPOINTMENTS =
  "SET_IS_LOADING_RECENT_APPOINTMENTS";
export const CLEAR_CUSTOMER_RECENT_APP_API_ERROR =
  "CLEAR_CUSTOMER_RECENT_APP_API_ERROR";

export const getCustomerRecentAppointments = customerId => {
  return {
    type: GET_CUSTOMER_RECENT_APPOINTMENTS,
    customerId: customerId
  };
};

export const setIsLoadingOnRecentAppointment = isLoading => {
  return {
    type: SET_IS_LOADING_RECENT_APPOINTMENTS,
    isLoading: isLoading
  };
};

export const clearCustomerRecentAppApiError = () => {
  return {
    type: CLEAR_CUSTOMER_RECENT_APP_API_ERROR
  };
};
